import React from 'react';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const revenueData = [
  { month: 'Jan', revenue: 12500, orders: 45 },
  { month: 'Feb', revenue: 15200, orders: 52 },
  { month: 'Mar', revenue: 18900, orders: 68 },
  { month: 'Apr', revenue: 17200, orders: 61 },
  { month: 'May', revenue: 21000, orders: 75 },
  { month: 'Jun', revenue: 24500, orders: 89 },
];

const planData = [
  { name: 'Premium', value: 45, color: '#4f46e5' },
  { name: 'Business', value: 30, color: '#10b981' },
  { name: 'Basic', value: 25, color: '#f59e0b' },
];

export default function AdminAnalytics() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Analytics Dashboard</h1>
        <p className="text-gray-600 mt-1">Business performance and insights</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">Total Revenue</p>
          <p className="text-2xl font-bold text-gray-900">,300</p>
          <p className="text-xs text-green-600 mt-1">↑ +23% from last quarter</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">Total Orders</p>
          <p className="text-2xl font-bold text-gray-900">390</p>
          <p className="text-xs text-green-600 mt-1">↑ +15% from last quarter</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">Avg Order Value</p>
          <p className="text-2xl font-bold text-gray-900"></p>
          <p className="text-xs text-green-600 mt-1">↑ +5% from last quarter</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">Customer Satisfaction</p>
          <p className="text-2xl font-bold text-gray-900">4.8/5.0</p>
          <p className="text-xs text-green-600 mt-1">Based on 245 reviews</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Revenue Trend</h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={revenueData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip formatter={(value) => '$' + value.toLocaleString()} />
                <Legend />
                <Line type="monotone" dataKey="revenue" name="Revenue ($)" stroke="#4f46e5" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Orders by Plan</h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie 
                  data={planData} 
                  cx="50%" 
                  cy="50%" 
                  labelLine={false} 
                  label={function(entry) {
                    return entry.name + ' ' + (entry.percent * 100).toFixed(0) + '%';
                  }} 
                  outerRadius={80} 
                  fill="#8884d8" 
                  dataKey="value" 
                  nameKey="name"
                >
                  {planData.map(function(entry, index) {
                    return <Cell key={'cell-' + index} fill={entry.color} />;
                  })}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Monthly Orders</h3>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="orders" name="Number of Orders" fill="#10b981" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
